export default __webpack_public_path__ + "static/media/user_no_photo.db7c26d0.png";